<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button type="button" class="btn btn-primary" (click)="openCreateModal()" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'RECEPTION']">
      Ajouter un contact
    </button>
  </div>

  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="interviewsTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="interviewDate" (sort)="onSort($event)">Date</th>
            <th scope="col" sortable="directedBy.id" (sort)="onSort($event)">Réalisé par</th>
            <th scope="col" class="text-center" sortable="interviewType" (sort)="onSort($event)">Type</th>
            <th scope="col" class="text-center" sortable="interviewTheme" (sort)="onSort($event)">Thème principal</th>
            <th scope="col" class="text-center" sortable="presence" (sort)="onSort($event)">Présence</th>
          </tr>
        </thead>
        <tbody>
          @for (interview of interviews.items; track interview) {
            <tr (click)="openConsultModal(interview.id)">
              <td></td>
              <td class="text-center">{{ interview.interviewDate | date }}</td>
              <td>{{ interview.directedByName }}</td>
              <td class="text-center">{{ interviewTypes.get($interviewType(interview.interviewType)) }}</td>
              <td class="text-center">{{ interview.interviewTheme }}</td>
              <td class="text-center">{{ presences.get($presence(interview.presence)) }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (interviews.items.length === 0) {
        <p>Le bénéficiaire n'a aucun contact.</p>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="interviews.totalItems"
      [page]="interviews.options.page"
      [pageSize]="interviews.options.limit"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="interviews.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
